/**
 * Карта маршрутов хоста.
 *
 * Пути собраны в один объект, потому что на них ссылаются и роутер,
 * и навигация, и редиректы гвардов. Строка, продублированная в трёх местах,
 * рано или поздно расходится ровно в одном из них.
 */
export const ROUTES = {
  root: '/',
  login: '/login',
  register: '/register',

  feed: '/feed',
  messages: '/messages',
  space: '/spaces/:spaceId',
  profile: '/profile/:username',
  bookmarks: '/bookmarks',
  notifications: '/notifications',
  settings: '/settings',
} as const

export function spacePath(spaceId: string): string {
  return `/spaces/${spaceId}`
}

export function profilePath(username: string): string {
  return `/profile/${username}`
}

/** Куда попадает пользователь сразу после входа. */
export const DEFAULT_AUTHENTICATED_ROUTE = ROUTES.feed
